<template>
  <div>
    <b-card header="Parâmetros">
      <b-row>
        <b-col cols="4">
          <b-form-group label="Protocolo">
            <b-input-group>
              <b-form-input
                v-model="filter.protocol"
                type="text"
                @change="onFilterChange"
              />
              <b-input-group-append>
                <b-button
                  variant="info"
                  title="Pesquisar"
                  @click="searchProtocol"
                  ><i class="fas fa-search" aria-hidden="true" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Dados">
            <b-form-select
              v-model="filter.fields"
              multiple
              :options="fieldsOpts"
              :select-size="6"
              @change="onFilterChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="*" class="ml-3">
          <b-button @click="clearParameters">Limpar</b-button>
        </b-col>
        <b-col cols="*" class="ml-2">
          <b-button @click="print"
            ><i class="fas fa-print" aria-hidden="true" /> Imprimir</b-button
          >
        </b-col>
      </b-row>
    </b-card>
    <b-card id="report">
      <span v-if="!complaint">Digite o protocolo e clique em Pesquisar</span>
      <template v-else>
        <b-row>
          <b-col>
            <h4>
              Denúncia {{ complaint.protocol }}
              <small v-if="complaint.previousProtocol">
                (Procotolo anterior: {{ complaint.previousProtocol }})</small
              >
              <span class="float-right"
                >Status: {{ getStatusText(complaint.status) }}</span
              >
            </h4>
            <p v-if="complaint.phoneServiceProtocol">
              <strong>Protocolo Telefônico: </strong
              >{{ complaint.phoneServiceProtocol }}
            </p>
            <strong>Recebida: </strong>{{ complaint.createdAt | datetime }}
            <span class="float-right">
              <strong>Última Movimentação: </strong
              >{{ complaint.updatedAt | datetime }}
            </span>
          </b-col>
        </b-row>
        <b-row v-if="hasSectionEnabled('information')">
          <b-col md="12">
            <template
              v-if="
                isMasterUser ||
                !(complaint.committee && complaint.committee.hideDenouncerData)
              "
            >
              <hr class="hr-text" />
              <h5 v-if="complaint.anonymous">Denúncia Anônima</h5>
              <h5 v-else>
                Denunciante
                <small
                  v-if="complaint.committee.hideDenouncerData && isMasterUser"
                  >(Os dados do denunciante estão ocultados para os membros do
                  comitê)</small
                >
              </h5>
              <template v-if="!complaint.anonymous || isMasterUser">
                <b-row>
                  <b-col cols="4">
                    <label>Nome:</label>
                    {{ complaint.denouncer.fullName | noInformation }}
                  </b-col>
                  <b-col cols="4">
                    <label>CPF:</label>
                    {{ complaint.denouncer.cpf | noInformation }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <label>Telefone:</label>
                    {{ complaint.denouncer.phone | noInformation }}
                  </b-col>
                  <b-col cols="4">
                    <label>Email:</label>
                    {{ complaint.denouncer.email | noInformation }}
                  </b-col>
                </b-row>
              </template>
            </template>
            <hr class="hr-text" />
            <b-row class="pb-3">
              <b-col md="12">
                <h5>Descrição</h5>
                <div>{{ complaint.text }}</div>
                <template v-if="complaint.submittedClassification">
                  <hr class="hr-text" data-content="Indicadores informados" />
                  <template v-for="opt in Object.values(ClassificationTypeMap)">
                    <div
                      v-if="
                        complaint.submittedClassification[opt] &&
                        ClassificationName[opt]
                      "
                      :key="opt"
                    >
                      <b>{{ ClassificationName[opt] }}:</b>
                      {{
                        (classificationMaps[opt] || {})[
                          complaint.submittedClassification[opt]
                        ]
                      }}<br />
                    </div>
                  </template>
                  <hr class="hr-text" />
                </template>
              </b-col>
            </b-row>
            <b-row class="pb-3">
              <b-col md="12">
                <h5>Data dos fatos</h5>
                <div>{{ complaint.date | noInformation }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-3">
              <b-col md="12">
                <h5>Local onde ocorreram os fatos</h5>
                <div>{{ complaint.location | noInformation }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-3">
              <b-col md="12">
                <h5>Como teve conhecimento dos fatos</h5>
                <div>{{ complaint.knowAbout | noInformation }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-3">
              <b-col md="12">
                <h5>Testemunhas ou pessoas que tiverem conhecimento</h5>
                <div>{{ complaint.witnesses | noInformation }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-3">
              <b-col md="12">
                <h5>Danos financeiros</h5>
                <div>{{ complaint.witnesses | noInformation }}</div>
              </b-col>
            </b-row>
            <b-row v-if="complaint.files.length > 0">
              <b-col md="12">
                <h5>Anexos</h5>
                <b-list-group>
                  <b-list-group-item
                    v-for="(file, idx) in complaint.files"
                    :key="idx"
                    class="d-flex justify-content-between align-items-center"
                  >
                    {{ file.name }}
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="hasSectionEnabled('classification')">
          <b-col>
            <hr class="hr-text" />
            <h4>Classificação</h4>
            <template v-if="complaint.classification">
              <b-row>
                <b-col v-if="complaint.classification.receivingMeans" md="4">
                  <strong>Meio de Recebimento: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.receivingMeans,
                      classificationOptions.receivingMeans
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.channelConfidence" md="4">
                  <strong>Confiança no Canal: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.channelConfidence,
                      classificationOptions.channelConfidence
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.origin" md="4">
                  <strong>Origem da Comunicação: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.origin,
                      classificationOptions.origin
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.reportingAgent" md="4">
                  <strong>Agente Denunciante: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.reportingAgent,
                      classificationOptions.reportingAgent
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.level" md="4">
                  <strong>Classificação/Classe Interna: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.level,
                      classificationOptions.level
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.nature" md="4">
                  <strong>Natureza: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.nature,
                      classificationOptions.nature
                    )
                  }}
                </b-col>
                <b-col
                  v-if="complaint.classification.responsibleDepartment"
                  md="4"
                >
                  <strong>Área responsável pelo tratamento: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.responsibleDepartment,
                      classificationOptions.responsibleDepartment
                    )
                  }}
                </b-col>
                <b-col
                  v-if="complaint.classification.involvedDepartment"
                  md="4"
                >
                  <strong>Setor da Ocorrência: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.involvedDepartment,
                      classificationOptions.involvedDepartment
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.businessGroup" md="4">
                  <strong>Empresa do Grupo: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.businessGroup,
                      classificationOptions.businessGroup
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.businessUnit" md="4">
                  <strong>Unidade/Posto/Filial: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.businessUnit,
                      classificationOptions.businessUnit
                    )
                  }}
                </b-col>
                <b-col v-if="complaint.classification.relatedProject" md="4">
                  <strong>Contrato/Projeto: </strong
                  >{{
                    getClassificationValue(
                      complaint.classification.relatedProject,
                      classificationOptions.relatedProject
                    )
                  }}
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
        <b-row v-if="hasSectionEnabled('committee')">
          <b-col cols="12">
            <hr class="hr-text" />
            <h4>Comissão de Apuração</h4>
            <template v-if="complaint.committee">
              <template v-if="complaint.committee.admin">
                <strong>Relator: </strong
                >{{ companyUsers[complaint.committee.admin].name }}
                {{ companyUsers[complaint.committee.admin].surname }}
                <em
                  v-if="!companyUsers[complaint.committee.admin].active"
                  class="text-warning"
                >
                  Inativo</em
                >
                <br />
              </template>
              <template v-if="complaint.committee.users">
                <strong>Membros:</strong>
                <ul>
                  <li
                    v-for="(user, idx) in complaint.committee.users"
                    :key="idx"
                  >
                    {{ companyUsers[user].name }}
                    {{ companyUsers[user].surname }}
                    <em v-if="!companyUsers[user].active" class="text-warning">
                      Inativo</em
                    >
                  </li>
                </ul>
              </template>
            </template>
          </b-col>
        </b-row>
        <b-row v-if="hasSectionEnabled('processing')">
          <b-col cols="12">
            <hr class="hr-text" />
            <h4>Processamento</h4>
            <b-card v-for="event in events" :key="event._id" no-header>
              <div>#{{ event.number }}</div>
              <label><strong>Tipo:</strong></label>
              {{ labelEventType(event.type) }}
              <br />
              <label
                v-if="event.type === EventType.STATUS_CHANGE"
                class="card-text"
              >
                <strong>Novo Status: </strong> {{ getStatusText(event.status) }}
              </label>
              <p class="card-text">
                <label><strong>Descrição:</strong></label>
                {{ event.description }}
              </p>
              <template v-if="event.type === EventType.WITH_ATTACHMENT">
                <b-list-group v-if="event.files && event.files.length > 0">
                  <b-list-group-item
                    v-for="(file, idx) in event.files"
                    :key="idx"
                    class="d-flex justify-content-between align-items-center"
                  >
                    {{ file.name }}
                  </b-list-group-item>
                </b-list-group>
                <b-alert v-else show variant="warning"
                  >Arquivo não recebido!</b-alert
                >
              </template>
              <p class="card-text">
                <small class="text-muted">
                  <i class="fa fa-calendar-alt" aria-hidden="true" />
                  {{ event.createdAt | datetime }} -
                  <template v-if="event.task && event.task.email">
                    <i
                      class="fa fa-user-friends text-warning"
                      aria-hidden="true"
                    ></i>
                    {{ event.task.email }}
                  </template>
                  <template v-else-if="companyUsers[event.user]">
                    <i class="fa fa-user" aria-hidden="true" />
                    {{ companyUsers[event.user].name }}
                    {{ companyUsers[event.user].surname }}
                  </template>
                  <template v-else>
                    <i class="fa fa-user-tie text-info" aria-hidden="true" />
                    {{ conformitaUsers[event.user].name }}
                    {{ conformitaUsers[event.user].surname }}
                  </template>
                </small>
              </p>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="hasSectionEnabled('denounced')">
          <b-col cols="12">
            <hr class="hr-text" />
            <h4>Investigados</h4>
            <ul>
              <li v-for="denounced in denounceds" :key="denounced._id">
                <strong>{{ denounced.name }}</strong>
                <br />
                <small class="text-muted">
                  {{ denounced.cpfcnpj || "Não informado" }}
                  {{ denounced.office ? " - " + denounced.office : "" }}
                  {{
                    denounced.department
                      ? " (" + denounced.department + ")"
                      : ""
                  }}
                </small>
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row v-if="hasSectionEnabled('external')">
          <b-col cols="12">
            <hr class="hr-text" />
            <h4>Acompanhamento Externo</h4>
            <b-card v-for="(monitoring, idx) in monitorings" :key="idx">
              <p class="card-text">
                <i class="fa fa-calendar-alt" aria-hidden="true" />
                {{ monitoring.createdAt | datetime }}<br />
                <template v-if="monitoring.type !== MonitoringType.RESPONSE">
                  <template v-if="companyUsers[monitoring.user]">
                    <i class="fa fa-user" aria-hidden="true" />
                    {{ companyUsers[monitoring.user].name }}
                    {{ companyUsers[monitoring.user].surname }}
                  </template>
                  <template v-else>
                    <i class="fa fa-user-tie text-info" aria-hidden="true" />
                    {{ conformitaUsers[monitoring.user].name }}
                    {{ conformitaUsers[monitoring.user].surname }}
                  </template>
                </template>
              </p>
              <p
                v-if="monitoring.type === MonitoringType.COMPANY"
                class="card-text"
              >
                {{ monitoring.description }}
              </p>
              <p
                v-else-if="monitoring.type === MonitoringType.RESPONSE"
                class="card-text text-info"
              >
                <i class="fas fa-reply" aria-hidden="true" />
                {{ monitoring.response.text }}
              </p>
            </b-card>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </div>
</template>

<script>
import humanizeDuration from "humanize-duration";
import { mapGetters } from "vuex";
import {
  getComplaint,
  findComplaintIdByProtocol,
  getEvents,
  getDenounceds,
  getMonitoring,
} from "../../../api/complaint";
import { getStatusText, labelEventType } from "../utils";
import { getSystemUsers } from "../../../api/user";
import { getCompanyUsers } from "../../../api/company";
import {
  ClassificationTypeMap,
  ClassificationName,
} from "../../../../../backend/models/ClassificationType.ts";
import EventType from "../../../../../backend/models/EventType.ts";
import MonitoringType from "../../../../../backend/models/MonitoringType.ts";

export default {
  name: "ComplaintsReport",
  data() {
    const fieldsOpts = [
      {
        value: "information",
        text: "Informações",
      },
      {
        value: "processing",
        text: "Processamento",
      },
      {
        value: "committee",
        text: "Comitê",
      },
      {
        value: "denounced",
        text: "Investigados",
      },
      {
        value: "classification",
        text: "Classificação",
      },
      {
        value: "external",
        text: "Acompanhamento Externo",
      },
    ];

    const defaultOpts = [];
    for (const opt of fieldsOpts) {
      defaultOpts.push(opt.value);
    }

    return {
      EventType,
      MonitoringType,
      ClassificationTypeMap,
      ClassificationName,
      printing: false,
      fieldsOpts,
      events: [],
      denounceds: [],
      monitorings: [],
      companyUsers: {},
      conformitaUsers: {},
      filter: {
        protocol: null,
        id: null,
        fields: defaultOpts,
      },
      currentFilter: {
        protocol: null,
        fields: [],
        id: null,
      },
      complaint: null,
      hcfg: { language: "pt", largest: 3 },
    };
  },
  computed: {
    ...mapGetters(["profile", "classificationOptions", "classificationMaps"]),
    masterUser() {
      const role = this.profile.role;
      return role === "root" || role === "company-root";
    },
    conformitaUser() {
      return !!this.conformitaUsers[this.profile._id];
    },
    isComplaintAdmin() {
      return this.profile._id === this.complaint.committee.admin;
    },
    isMasterUser() {
      return this.profile.role === "root";
    },
  },
  methods: {
    getStatusText,
    labelEventType,
    duration(value) {
      return humanizeDuration(value, this.hcfg);
    },
    clearParameters() {
      this.filter.protocol = null;
      this.filter.fields = [];
      this.currentFilter = {
        protocol: null,
        fields: [],
      };
      this.$set("complaint", null);
    },
    onFilterChange() {
      this.currentFilter.protocol = this.filter.protocol;
      this.currentFilter.fields = this.filter.fields;
    },

    getClassificationValue(value, options) {
      return options.find((i) => i.value === value).text;
    },

    hasSectionEnabled(section) {
      return this.currentFilter.fields.indexOf(section) !== -1;
    },

    print() {
      // Pass the element id here
      this.printing = true;
      this.$htmlToPaper("report", () => {
        this.printing = false;
        console.log("Printing done or got cancelled!");
      });
    },
    async loadEvents(complaint) {
      const response = await getEvents(complaint._id);
      this.events = response.data;
    },

    async loadMonitoring(complaint) {
      const response = await getMonitoring(complaint._id);
      this.monitorings = response.data;
    },

    async loadDenounceds(complaint) {
      const response = await getDenounceds(complaint._id);
      this.denounceds = response.data;
    },

    async loadClassifications(complaint) {
      await this.$store.dispatch(
        "RefreshCompanyClassifications",
        complaint.company._id
      );
    },

    async searchProtocol() {
      let complaintId;
      try {
        const response = await findComplaintIdByProtocol(
          this.currentFilter.protocol
        );
        complaintId = response.data._id;
      } catch (error) {
        if (error.response.data) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        return;
      }

      let complaint;
      try {
        const response = await getComplaint(complaintId);
        complaint = response.data;
      } catch (error) {
        if (error.response.data) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        return;
      }

      let resp = await getCompanyUsers(complaint.company._id, true);
      this.companyUsers = resp.data.reduce((obj, user) => {
        obj[user["_id"]] = user;
        return obj;
      }, {});

      resp = await getSystemUsers();
      this.conformitaUsers = resp.data.reduce((obj, user) => {
        obj[user["_id"]] = user;
        return obj;
      }, {});

      await this.loadEvents(complaint);
      await this.loadMonitoring(complaint);
      await this.loadClassifications(complaint);
      await this.loadDenounceds(complaint);

      this.$set(this, "complaint", complaint);
    },
    getDisplayId(id) {
      if (!id) return "";

      const cleanId = id.replace(/\D/g, "");

      // If it's 11 digits, it's a CPF
      if (cleanId.length === 11) {
        return `CPF: ${cleanId}`;
      }
      // If it's 14 digits, it's a CNPJ
      else if (cleanId.length === 14) {
        return `CNPJ: ${cleanId}`;
      }
      // Otherwise, it's an internal ID
      else {
        return `ID Interno: ${cleanId}`;
      }
    },
  },
};
</script>
<style scoped>
/* Harmonize the report card style with the parameters card */
#report.card,
.card[header="Parâmetros"] {
  border: none;
  border-radius: 8px;
}
</style>
